// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('TopCallToActionExplainerApp')

function TopCallToActionExplainerApp(props) {
  if (!props.androidHref && !props.iosHref) {
    return null
  }
  return tag('div', {
    className: bem.block()
  },
    tag('div', {
      className: bem.element('heading')
    },
      'Get the app.'
    ),
    props.androidHref && tag('a', {
      className: bem.element('button', 'android'),
      href: props.androidHref,
      onClick: props.onAndroidHrefClick
    },
      `Download for Android on Google Play`
    ),
    props.iosHref && tag('a', {
      className: bem.element('button', 'ios'),
      href: props.iosHref,
      onClick: props.onIosHrefClick
    },
      `Download for iOS on the App Store`
    )
  )
}

TopCallToActionExplainerApp.propTypes = {
  androidHref: PropTypes.string,
  iosHref: PropTypes.string,
  // Callbacks
  onAndroidHrefClick: PropTypes.func,
  onIosHrefClick: PropTypes.func
}

module.exports = TopCallToActionExplainerApp
